import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// CRITICAL: Unregister any service workers to fix Safari "Service Worker context closed" issues
// This ensures a clean slate and prevents caching issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister().then(success => {
        if (success) {
          console.log('[SW] Service worker unregistered successfully');
        }
      });
    }
  }).catch(err => {
    console.warn('[SW] Failed to unregister service workers:', err);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
